<template>
  <div class="body">
    <div class="header" v-if="isLoggedIn">
      <Header></Header>
    </div>
    <div class="navigation" v-if="isLoggedIn">
      <div class="nav--mobile">
        <MobileNav></MobileNav>
      </div>
      <div class="nav--desktop">
        <DesktopNav></DesktopNav>
      </div>
    </div>
    <simplebar class="content--overflow" data-simplebar-auto-hide="false">
      <div class="content">
        <div class="container">
          <router-view></router-view>
        </div>
      </div>
    </simplebar>
    <flash-message class="messages"></flash-message>
  </div>
</template>

<script>
import Header from "./components/Header";
import MobileNav from "./components/navigation/MobileNav";
import DesktopNav from "./components/navigation/DesktopNav";
import { mapGetters } from "vuex";

export default {
  components: {
    MobileNav,
    DesktopNav,
    Header
  },
  computed: {
    ...mapGetters(["isLoggedIn"])
  }
};
</script>

<style lang="scss">
</style>